import { render, staticRenderFns } from "./ChangeEmail.form.vue?vue&type=template&id=6d55992e&scoped=true&lang=pug&"
import script from "./ChangeEmail.form.vue?vue&type=script&lang=ts&"
export * from "./ChangeEmail.form.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeEmail.form.vue?vue&type=style&index=0&id=6d55992e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d55992e",
  null
  
)

export default component.exports